import { usePrevious } from '@sequencehq/utils'
import { useSequenceInfiniteQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useNotifications } from '@sequencehq/core-components'
import { useEffect, useMemo } from 'react'
import { ExecutionFilters } from '../types'

export const useAllAutomationExecutions = ({
  filters,
  enabled = true
}: {
  filters?: ExecutionFilters
  enabled?: boolean
} = {}) => {
  const { displayNotification } = useNotifications()
  const automationExecutionsInfiniteQuery = useSequenceInfiniteQuery(
    dashboardv99990101Client.getAutomationExecutions,
    {
      limit: 40,
      status: filters?.status,
      triggerType: filters?.workflowType,
      requestorId: filters?.requestorId,
      sortBy: 'startDate',
      sortOrder: 'DESC'
    },
    {
      retry: false,
      enabled
    }
  )

  const prevErrorState = usePrevious(
    automationExecutionsInfiniteQuery.infiniteQuery.isError
  )

  useEffect(() => {
    if (
      automationExecutionsInfiniteQuery.infiniteQuery.isError &&
      !prevErrorState
    ) {
      displayNotification('We could not load your workflow executions', {
        type: 'error'
      })
    }
  }, [
    prevErrorState,
    automationExecutionsInfiniteQuery.infiniteQuery.isError,
    displayNotification
  ])

  const allAutomationExecutions = useMemo(() => {
    return (
      automationExecutionsInfiniteQuery.infiniteQuery.data?.pages.flatMap(
        page => page.items
      ) ?? []
    )
  }, [automationExecutionsInfiniteQuery.infiniteQuery.data])

  return {
    isPending:
      enabled && automationExecutionsInfiniteQuery.infiniteQuery.isPending,
    isFetchingNextPage:
      automationExecutionsInfiniteQuery.infiniteQuery.isFetchingNextPage,
    automationExecutions: allAutomationExecutions,
    hasNextPage: automationExecutionsInfiniteQuery.infiniteQuery.hasNextPage,
    fetchNextPage: automationExecutionsInfiniteQuery.infiniteQuery.fetchNextPage
  }
}
